import { render, staticRenderFns } from "./PartySection.vue?vue&type=template&id=4f84e058"
import script from "./PartySection.vue?vue&type=script&lang=js"
export * from "./PartySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports